// Mixin to handle sleep timer functionality and interact with player mixin for control

import moment from 'moment';

import { i18n } from '@/i18n';

export default {
  computed: {
    sleepTimerIsSet() {
      return this.$store.state.player.sleepTimerStartedAt > 0 && this.$store.state.player.sleepTimerDuration > 0;
    },
    turnOffAt() {
      return this.sleepTimerIsSet ? this.$store.state.player.sleepTimerStartedAt + this.$store.state.player.sleepTimerDuration : 0;
    },
  },

  methods: {
    openSleepTimerActionSheet() {
      let that = this;
      let store = this.$store;
      let ons = this.$ons;
      let TimerOptions = [];
      let TimerOptionCallbacks = [];
      if (this.sleepTimerIsSet) {
        TimerOptions.push(i18n.t("ui.disable"));
        TimerOptionCallbacks.push(() => {
          store.dispatch('player/resetSleepTimer');
          ons.notification.toast(i18n.t("messages.sleep_timer_off"), { timeout: 1500, animation: 'fall' });
        });
      }
      if (that.currentUser.sleep_timer_first_duration) {
        TimerOptions.push(i18n.t(`sleep_timer_settings.${that.currentUser.sleep_timer_first_duration}sec`));
        TimerOptionCallbacks.push(() => {
          store.dispatch('player/setSleepTimer', that.currentUser.sleep_timer_first_duration);
          ons.notification.toast(i18n.t("messages.sleep_timer_set", { time: moment.unix(this.turnOffAt).format("H:mm") }), { timeout: 1500, animation: 'fall' });
        });
      }
      if (that.currentUser.sleep_timer_second_duration) {
        TimerOptions.push(i18n.t(`sleep_timer_settings.${that.currentUser.sleep_timer_second_duration}sec`));
        TimerOptionCallbacks.push(() => {
          store.dispatch('player/setSleepTimer', that.currentUser.sleep_timer_second_duration);
          ons.notification.toast(i18n.t("messages.sleep_timer_set", { time: moment.unix(this.turnOffAt).format("H:mm") }), { timeout: 1500, animation: 'fall' });
        });
      }
      if (that.currentUser.sleep_timer_third_duration) {
        TimerOptions.push(i18n.t(`sleep_timer_settings.${that.currentUser.sleep_timer_third_duration}sec`));
        TimerOptionCallbacks.push(() => {
          store.dispatch('player/setSleepTimer', that.currentUser.sleep_timer_third_duration);
          ons.notification.toast(i18n.t("messages.sleep_timer_set", { time: moment.unix(this.turnOffAt).format("H:mm") }), { timeout: 1500, animation: 'fall' });
        });
      }
      TimerOptions.push(i18n.t('ui.close'));
      this.$ons.openActionSheet({
        title: this.sleepTimerIsSet ? i18n.t("messages.sleep_timer_at", { time: moment.unix(this.turnOffAt).format("H:mm") }) : i18n.t("ui.sleep_timer.set_sleep_timer"),
        cancelable: true,
        buttons: TimerOptions
      }).then(function (index) {
        if (index >= 0 && index < TimerOptionCallbacks.length) {
          TimerOptionCallbacks[index]();
        }
      });
    },
  },
};
